var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { align: "center" } },
    [
      _c(
        "v-flex",
        { attrs: { md10: "" } },
        [
          _c(
            "v-card",
            { staticClass: "rounded-card" },
            [
              _c(
                "v-form",
                { ref: "form", staticClass: "col-md-12" },
                [
                  _c(
                    "v-container",
                    { attrs: { "grid-list-md": "" } },
                    [
                      _c(
                        "div",
                        { attrs: { align: "left" } },
                        [
                          _c("h2", [
                            _vm._v(
                              "\n              Configuración de Mapeos\n            "
                            )
                          ]),
                          _c("v-divider"),
                          _c("br")
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { attrs: { align: "left" } },
                        [
                          _c(
                            "h3",
                            [
                              _vm._v(
                                "\n              Mapeos de Body JS\n              "
                              ),
                              !_vm.modoVer
                                ? _c(
                                    "v-btn",
                                    {
                                      attrs: { flat: "", icon: "", small: "" },
                                      on: {
                                        click: function($event) {
                                          return _vm.handleValidarScript("js")
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { color: "#228B22" } },
                                        [_vm._v("play_arrow")]
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _c("v-divider"),
                          _c("br")
                        ],
                        1
                      ),
                      _c(
                        "v-layout",
                        { attrs: { wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { md12: "" } },
                            [
                              _c("CodeView", {
                                attrs: { readOnly: _vm.modoVer },
                                on: { blur: _vm.handleMapeoJsBlur },
                                model: {
                                  value: _vm.mapeoJs,
                                  callback: function($$v) {
                                    _vm.mapeoJs = $$v
                                  },
                                  expression: "mapeoJs"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { attrs: { align: "left" } },
                        [
                          _c(
                            "h3",
                            [
                              _vm._v(
                                "\n              Mapeos de Body Template\n              "
                              ),
                              !_vm.modoVer
                                ? _c(
                                    "v-btn",
                                    {
                                      attrs: { flat: "", icon: "", small: "" },
                                      on: {
                                        click: function($event) {
                                          return _vm.handleValidarScript(
                                            "template"
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { color: "#228B22" } },
                                        [_vm._v("play_arrow")]
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _c("v-divider"),
                          _c("br")
                        ],
                        1
                      ),
                      _c(
                        "v-layout",
                        { attrs: { wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { md12: "" } },
                            [
                              _c("CodeView", {
                                attrs: {
                                  language: "application/xml",
                                  readOnly: _vm.modoVer
                                },
                                on: { blur: _vm.handleMapeoTemplateBlur },
                                model: {
                                  value: _vm.mapeoTemplate,
                                  callback: function($$v) {
                                    _vm.mapeoTemplate = $$v
                                  },
                                  expression: "mapeoTemplate"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("ValidarBodyModal", {
        attrs: {
          show: _vm.muestraModalValidar,
          script: _vm.scriptValidar,
          tipo: _vm.tipo
        },
        on: { cerrar: _vm.handleCierreModal }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }